module.exports = __webpack_public_path__ + "static/media/template-assign-bulk-csv.fa7aa953.png";